// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"368":"5a10b3f2","976":"b60901bc"}[chunkId] + ".chunk.js";
};